<template>
  <div class="ac-body-container flex-row just-between">
    <div>
      <div class="sub-header">
        When members request to speak to a technician, prompt them to:
      </div>
      <SACRadio
        name="handle-chat"
        field="method"
        value="smac"
        :checked="method === 'smac'"
        :change="onChange"
        label="enable chat with a SmartAC.com technician (recommended)"
        :disable="adminRole !== 'admin'"
      />
      <SACRadio
        name="handle-chat"
        field="method"
        value="phone"
        :checked="method === 'phone'"
        :change="onChange"
        label="disable SmartAC.com Support Chat and direct to my company"
        :disable="adminRole !== 'admin'"
      />      
    </div>
    <div class="flex-row">
      <div class="flex-column just-end">
        <img
          src="@shared/assets/img/partner-detail/my-tech.png"
          class="pc-phone-img"
        />
        <div class="pc-preview-title">My Tech</div>
        <div class="sac__font-12 n60 text-center">Member App</div>
      </div>
      <div>
        <ServiceRequestPreview
          :phone="supportPhone"
          :method="method"
          :email="supportEmail"
          :primaryColor="primaryColor"
          :companyName="companyName"
          :logoPreview="logoPreview"
        />
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SACRadio from '@shared/components/sac/SACRadio.vue';
import SACInput from '@shared/components/sac/SACInput.vue';
import ServiceRequestPreview from './branding/ServiceRequestPreview.vue';

export default {
  name: 'TechChat',
  components: {
    SACRadio,
    SACInput,
    ServiceRequestPreview,
  },
  mixins: [partnerSettingsMixin],
  props: {
    method: String,
    phone: String,
    email: String,
    onChange: Function,
    errorObj: Object,
    partnerSettings: Object,
    primaryColor: String,
    companyName: String,
    logoPreview: String,
  },
  computed: {
    supportPhone() {
      const {
        SERVICE_REQUEST_SUPPORT_PHONE = '',
      } = this.partnerSettings;
      const contact = this.contacts?.find((x) => x.contactType === 'Support');

      return contact ? contact.phone : SERVICE_REQUEST_SUPPORT_PHONE;
    },
    supportEmail() {
      const {
        SERVICE_REQUEST_SUPPORT_EMAIL = '',
      } = this.partnerSettings;
      const contact = this.contacts?.find((x) => x.contactType === 'Support');

      return contact ? contact.email : SERVICE_REQUEST_SUPPORT_EMAIL;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}

.ac-content-container {
  &:not(:last-child) {
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 2px solid $N20;
  }
}

.ac-input-container,
.sac-radio-container {
  margin-top: 12px;
  margin-bottom: 0px !important;
}

.email-input {
  padding: 0 10px;
  width: 50%;
  min-width: 500px;
  background-color: $NBLUE5;
  height: 40px;
  border-radius: 4px;
  margin-top: 10px;
}

.email-invalid {
  background-color: $TOMATO25;
}

.recipient-table {
  border: 2px solid $NBLUE20;
  width: 50%;
  min-width: 500px;
  border-radius: 6px;

  .r-table-header {
    display: grid;
    width: 100%;
    grid-template-columns: auto 1fr 1fr;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    padding: 8px 10px;
    font-weight: 600;
    background-color: $NBLUE10;
    color: $N100;
  }

  .r-table-list {
    display: grid;
    overflow: auto;
    max-height: 300px;

    .r-emails {
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      justify-content: flex-start;
      height: 45px;
      padding: 0 12px;
      border-top: 2px solid $NBLUE20;
      font-size: 1rem;
      font-weight: 500;
      color: $N80;
    }
  }
}

.body {
  font-size: 0.875rem;
  margin-top: 8px;
  margin-bottom: 8px;
  color: $N80;
}

.pc-phone-img {
  height: 500px;
}

.pc-preview-title {
  margin-top: 34px;
  text-align: center;
}
</style>
